var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"o-map-tool-group",on:{"mousedown":function($event){$event.stopPropagation();},"mousemove":function($event){$event.stopPropagation();},"pointerdown":function($event){$event.stopPropagation();}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }